import React from 'react';
import CrudManager from './CrudManager';
import { adminApi } from '../../lib/api';

const FAQ_FIELDS = [
  { name: 'question', label: 'Question', required: true },
  { name: 'answer', label: 'Answer', type: 'textarea', required: true, rows: 4 },
  { name: 'order', label: 'Display Order', type: 'number' },
];

const FaqsAdmin = () => (
  <CrudManager
    title="FAQs"
    description="Frequently asked questions displayed on the About page"
    api={adminApi.faqs}
    fields={FAQ_FIELDS}
    itemLabel="FAQ"
    renderItem={(item) => (
      <div>
        <h3 className="text-[#EADBC8] font-semibold mb-1">{item.question}</h3>
        <p className="text-gray-400 text-sm line-clamp-2">{item.answer}</p>
        <p className="text-gray-500 text-xs mt-2">Order: {item.order}</p>
      </div>
    )}
  />
);

export default FaqsAdmin;
